import React, {  } from 'react'
import { Card, CardActions } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

function NftCard({ image, title, content, handleClick }) {
    
    return (
        <Card className='nft-card' sx={{ width: "80%", marginLeft: "10%", height: "100%", backgroundColor: "#c6643e", position: "relative", overflow: "visible", borderRadius: "20px" }}>
            <CardMedia
                component="img"
                alt="green iguana"
                image={image}
                sx={{ borderRadius: "20px" }}
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div" className='nft-card-title'>
                    {title}
                </Typography>
                <Typography variant="h5" component="div" className='nft-card-content'>
                    {content}
                </Typography>
            </CardContent>
            <CardActions sx={{ position: "absolute", bottom: "-40px", left: "50%", transform: "translateX(-50%)" }}>
                <button className='second-button' onClick={handleClick}>{title === "Exclusive Presale Access NFT" ? "Mint" : "Detail"}</button>
            </CardActions>
        </Card>
    );
}
export default NftCard;